import React from "react";
import { Link } from "react-router-dom";
export default class Home extends React.Component {
    render() {
        return<div>
        <div className="container-fluid p-0">
        <div id="header-carousel" className="carousel slide carousel-fade" data-ride="carousel">
            <ol className="carousel-indicators">
                <li data-target="#header-carousel" data-slide-to="0" className="active"></li>
                <li data-target="#header-carousel" data-slide-to="1"></li>
                <li data-target="#header-carousel" data-slide-to="2"></li>
            </ol>
            <div className="carousel-inner">
                <div className="carousel-item active">
                    <img className="img-fluid" src="img/carousel-1.jpg" alt="pic"/>
                    <div className="carousel-caption d-flex align-items-center justify-content-center">
                        <div className="p-5" style={{width: "100%", MaxWidth: "900px"}}>
                            <h5 className="text-primary text-uppercase mb-md-3">Cleaning Services</h5>
                            <h1 className="display-3 text-white mb-md-4">Best Quality Solution In Cleaning</h1>
                            <Link to="/Contact" className="btn btn-primary">Contact Us</Link>
                        </div>
                    </div>
                </div>
                <div className="carousel-item">
                    <img className="img-fluid" src="img/carousel-22.jpg" alt="pic"/>
                    <div className="carousel-caption d-flex align-items-center justify-content-center">
                        <div className="p-5" style={{width: "1366px", MaxWidth: "600px"}}>
                            <h5 className="text-primary text-uppercase mb-md-3">Carpenter Services</h5>
                            <h1 className="display-3 text-white mb-md-4">Professional Carpenter Services</h1>
                            <Link to="/Contact" className="btn btn-primary">Contact Us</Link>
                        </div>
                    </div>
                </div>
                <div className="carousel-item">
                    <img className="img-fluid" src="img/carousel-3.jpg" alt="pic"/>
                    <div className="carousel-caption d-flex align-items-center justify-content-center">
                        <div className="p-5" style={{width: "100%", MaxWidth: "900px"}}>
                            <h5 className="text-primary text-uppercase mb-md-3">Plumbing Services</h5>
                            <h1 className="display-3 text-white mb-md-4">Experienced & Expert Plumber</h1>
                            <Link to="/Contact" className="btn btn-primary">Contact Us</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
     {/* contact */}
    <div className="container-fluid pb-5 contact-info">
        <div className="row">
            <div className="col-lg-4 p-0">
                <div className="contact-info-item d-flex align-items-center justify-content-center bg-primary text-white py-4 py-lg-0">
                    <i className="fa fa-3x fa-map-marker-alt text-secondary mr-4"></i>
                    <div className="">
                        <h5 className="mb-2">Our Office</h5>
                        <p className="m-0">123 Street, New York, USA</p>
                    </div>
                </div>
            </div>
            <div className="col-lg-4 p-0">
                <div className="contact-info-item d-flex align-items-center justify-content-center bg-dark text-white py-4 py-lg-0">
                    <i className="fa fa-3x fa-envelope-open text-primary mr-4"></i>
                    <div className="">
                        <h5 className="mb-2">Email Us</h5>
                        <p className="m-0">info@example.com</p>
                    </div>
                </div>
            </div>
            <div className="col-lg-4 p-0">
                <div className="contact-info-item d-flex align-items-center justify-content-center bg-primary text-white py-4 py-lg-0">
                    <i className="fa fa-3x fa-phone-alt text-secondary mr-4"></i>
                    <div className="">
                        <h5 className="mb-2">Call Us</h5>
                        <p className="m-0">+012 345 6789</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    {/* about */}
    <div className="container-fluid py-5 mb-5">
        <div className="container">
            <div className="row">
                <div className="col-lg-5">
                    <div className="d-flex flex-column align-items-center justify-content-center bg-about rounded h-100 py-5 px-3">
                        <i className="fa fa-5x fa-award text-primary mb-4"></i>
                        <h1 className="display-2 text-white mb-2" data-toggle="counter-up">25</h1>
                        <h2 className="text-white m-0">Years Experience</h2>
                    </div>
                </div>
                <div className="col-lg-7 pt-5 pb-lg-5">
                    <h6 className="text-secondary font-weight-semi-bold text-uppercase mb-3">Learn About Us</h6>
                    <h1 className="mb-4 section-title">We Provide The Best Cleaning Services</h1>
                    <h5 className="text-muted font-weight-normal mb-3">Eos kasd eos dolor vero vero, lorem stet diam rebum. Ipsum amet sed vero dolor sea lorem justo est dolor eos</h5>
                    <p>Invidunt lorem justo sanctus clita. Erat lorem labore ea, justo dolor lorem ipsum ut sed eos, ipsum et dolor kasd sit ea justo. Erat justo sed sed diam. Ea et erat ut sed diam sea ipsum est dolor</p>
                    <div className="d-flex align-items-center pt-4">
                        <Link to="/Contact" className="btn btn-primary mr-5">Learn More</Link>
                        <button type="button" className="btn-play" data-toggle="modal"
                            data-src="https://www.youtube.com/embed/DWRcNpR6Kdc" data-target="#videoModal">
                            <span></span>
                        </button>
                        <h5 className="font-weight-normal text-white m-0 ml-4 d-none d-sm-block">Play Video</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
        </div>

        
    }
}